import { Component, OnInit,ViewChild, Input } from '@angular/core';
import { NavParams, ModalController,Platform ,IonInfiniteScroll} from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { CommonService } from 'src/service/common.service';
import { ActivatedRoute,Router } from '@angular/router';
import { WebParameterContext,WebResponesContext } from 'src/model/common';
import { MessageclientService, NativeService } from 'src/service';
declare var app;
@Component({
  selector: 'app-codeless-returnslist',
  templateUrl: './codeless-returnslist.page.html',
  styleUrls: ['./codeless-returnslist.page.scss'],
})
export class CodelessReturnslistPage implements OnInit {
  searchValue:string = null;//查询内容
  searchValueProduct:string = null;
  month:any="";
  RecordCount: Number = 0;//列表总数量
  dataArrayList: Array<any> = [];//数据列表
  dataArrayListTag:Array<any> = []; // 标签列表
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  webRespone:WebResponesContext = new WebResponesContext();//返回结果处理对象
  apiObj = {
    status: false,
    msg: ''
};//接口状态
PageNumber:number=1;//当前第几页 默认第一页
loading: boolean = false;//加载效果
vipTypeId:string="";//销量类型id
vipTypeArr=[];//订单类型数组
selectVal = null;//搜索月份 开始时间
selectValtext:string ="请选择"; //  默认空的显示
selectValsell= null; // 搜索 结束时间
selectValsellText:string="请选择";
selectChecked:boolean=true;//注册日期
selectrue:boolean=true; // 按钮点击
  constructor(
    private platform: Platform,
    public modalController: ModalController,
    public  navParams: NavParams,
    public http:HttpCustomerService,
    public com:CommonService,
    public msg:MessageclientService,
    private activaRouter: ActivatedRoute,
    public native: NativeService,
    private router: Router,
  ) { 

    this.month = this.com.getNow;
   
    const _date = new Date();
    const _month = _date.getMonth() + 1;
    // this.selectVal = _date.getFullYear() + "/" + (_month < 10 ? ("0" + _month) : _month);
    // this.selectValsell = _date.getFullYear() + "/" + (_month < 10 ? ("0" + _month) : _month);
    this.selectVal = this.com.getNow;
    this.selectValsell = this.com.getNow;
    
  }

  ngOnInit() {
    let that = this;
    that.LoadData(1);
    that.vipTypeArr.push(
      {
        a_Name:"全部"
      },{
      a_Name:"扫码归巢"
    },{
      a_Name:"扫码销量"
    },{
      a_Name:"自然销量"
    },
    );
    // if(vipArr.length>0){
    //   that.vipTypeArr=vipArr;
    // }else{
    //   that.LoadVipType();
    // }
    that.vipTypeId="";
  }
        /**
   * 下拉刷新数据
   * @param event
   */
  doRefresh(event){
    const that=this;
      that.LoadData(1);

    event.target.pullMax=500;
    event.target.pullMin=100;
    event.target.complete();
  }
    /**
   * 搜索事件
   * @param e 
   */
  serarEvent(e,type:string = 'type'){ 
    if(e.keyCode == 13 || type=='search'){
      const that=this;
      if(that.selectVal &&that.selectValsell ){
        let beginDate:number = parseInt(that.selectVal.replace(/-/g,""));
        let endDate:number = parseInt(that.selectValsell.replace(/-/g,""));
        if(endDate< beginDate){
          that.msg.Alert("结束日期必须要大于开始日期哦！");
          return;
        }
      }
      that.LoadData(1);
    }
  }
  serarEventfirst(e,type:string = 'type'){ 
    if(e.keyCode == 13 || type=='search'){
      const that=this;
      if(that.selectVal &&that.selectValsell ){
        let beginDate:number = parseInt(that.selectVal.replace(/-/g,""));
        let endDate:number = parseInt(that.selectValsell.replace(/-/g,""));
        if(endDate< beginDate){
          that.msg.Alert("结束日期必须要大于开始日期哦！");
          return;
        }
      }
      that.LoadData(1);
    }
  }
    //会员类型改变
    changeTypeSelect(e){
      const that=this;
      that.vipTypeId=e.target.value;
      if(that.vipTypeId=="全部"){
        that.vipTypeId="";
      }
      
      that.LoadData(1);
    }
    EventDateTimeClick(){
      let that = this;
      console.log(that.selectVal);
      //debugger;
      let _obj = {
        value: that.selectVal,
        format: "yyyymmdd"
      };
      that.native.IosselectDateTime(_obj).then(data => {
        that.selectVal = that.formatDate(data.value);
        that.selectChecked=true;
        // that.LoadData(1);
      }).catch(eror => {
        console.log(eror);
        // that.selectVal = "";
        // console.log(that.selectVal,"取消的月份");
      });
    }
    EventDateTimeClicksell(){
      let that = this;
      console.log(that.selectValsell ,"llllllll")
      // if(that.selectValsell = ""){
      //   that.selectrue = true;
      // }
        console.log(that.selectValsell);
        let _obj = {
          value: that.selectValsell,
          format: "yyyymmdd"
        };
        that.native.IosselectDateTime(_obj).then(data => {
          let beginDate = new Date(that.selectVal.replace(/-/g,"/")).getTime();
          let endDate = new Date(that.selectValsell.replace(/-/g,"/")).getTime();
          that.selectValsell = that.formatDate(data.value);
          console.log( that.selectValsell,"选择的月份");
          that.selectrue = true;
          // that.LoadData(1);
        }).catch(eror => {
          console.log(eror);
          // that.selectValsell = "";
          // console.log(that.selectValsell,"取消的月份");
        });  
    }
    close(){
      const that =this;
      that.selectrue = false;
      that.selectValsell = "";
      that.LoadData(1);
    }
    close2(){
      const that =this;
      that.selectChecked = false;
      that.selectVal = "";
      that.LoadData(1);
    }
  formatDate(date){
    if(date){
      let _date = new Date(date.replace(/-/g,"/"));
      let _y = _date.getFullYear();
      let _m = _date.getMonth()+1;
      let _d = _date.getDate();
      return _y + "-" + (_m < 10?"0"+_m:_m) + "-"+(_d < 10? "0"+_d:_d);
    }else{
      return date;
    }
  }

    // 确定按钮
    comfireModal() {
      // let codeless:Array<any>= ["a", "d", "c", "b"];//获取选中的id
      const that=this;
      console.log("确认按钮");
      this.modalController.dismiss({
        "result": that.webRespone,
        "type": "1"
      });
      // that.webRespone.Status=codeless;  // 选中的列表传输的数据
     
    }
    //  取消按钮
     dismissModal() {
      const that=this;
      that.webRespone.Status=new Array<any>();
      that.webRespone.ResponseMessage.Success=false;
      that.modalController.dismiss({
        "result":  that.webRespone,
      });
      
    }
    // 退单按钮
    comfireModalsure(item){
      const that=this;
      console.log("确认按钮");
      const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
      let body = new WebParameterContext();
      body.Account = that.com.GetAccount;
      let IsNotBarcode ={
        "IsNotBarcode":1
      }
      body.ConfigName = "ProductReturn";
      body.OpType = "QUERY";
      body.ConfigType = "form";
      body.RowsPerPage = app.RowsPerPage;
      body.Client.PageName = PageName;
      body.Client.ApiType = "Element";
      body.Client.ClientType = 2;
      body.SpecialParameter = JSON.stringify(IsNotBarcode);
      let typeObj = {};
      typeObj["Order_ID"] =item.a_Order_ID;
      body.RequestBody = JSON.stringify(typeObj);
      that.http.post(app.DEFAULTURL, body).then(data => {
       
        if (data.ResponseMessage.Success) {
            console.log(data.Status,"++++++++++++");
            console.log(data.Status.Datas,"++++++++++++");
          // console.log(that.dataArrayList, "dataArrayList");
            
        this.modalController.dismiss({
          "result": that.webRespone,
        });
          let listArr:Array<any> = [];
        that.webRespone.Status=data.Status.Datas||[];  // 选中的列表传输的数据
        let _newList:any = {};
        _newList=data.Status.Datas||{};
        debugger;
        if(_newList["ProductData"]){
          _newList["ProductData"].forEach(p => {
            p.newNum=p.Num;
          });
          listArr=_newList;
        }
        if(_newList["GiftData"]){
          _newList["GiftData"].forEach(pt => {
            pt.Num=pt.a_Num;
          });
          listArr=_newList;
        }
    
        that.com.setHistoryUrl(true);
        that.com.Go("/tabs/contact/A2orderWithoutCode/" + this.com.getNowDatetime,{"listArr":JSON.stringify(listArr)});
        // that.router.navigate(["/tabs/contact/A2orderWithoutCode/" + this.com.getNowDatetime], {
        //   queryParams: {
        //     listArr: JSON.stringify(listArr),
        //   }
        // });
        }else{
            that.msg.Alert(data.ResponseMessage.ErrorMessage);
        }
  
      }).catch(error => {
        console.log(error)
      });

    }
    // 拿数据
    loadMoreData(event) {
      let that = this;
      if (that.RecordCount == that.dataArrayList.length) {
        if (that.infiniteScroll) {
          that.infiniteScroll.disabled = true;
        }
  
      } else {
        that.PageNumber++;
        this.LoadData(that.PageNumber);
      }
    }
  
    LoadData(PageNumber) {
      var that = this;
      that.PageNumber = PageNumber;
      if (PageNumber == 1) {
        that.loading = false;
        that.apiObj['status'] = false;
        that.apiObj['msg'] = '';
      }
  
      const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
      let body = new WebParameterContext();
      body.Account = that.com.GetAccount;
  
      body.ConfigName = "GetNotBarcodeList";
      body.OpType = "QUERY";
      body.ConfigType = "view";
      body.Client.PageName = PageName;
      body.Client.ApiType = "Element";
      body.Client.ClientType = 2;
      body.PageNumber = PageNumber;
      body.RowsPerPage = app.RowsPerPage;
      let typeObj = {};
      if(that.searchValue){
        typeObj["Name"] = that.searchValue;
      }
      if(that.searchValueProduct){
        typeObj["Product"] = that.searchValueProduct;
      }
       
      
      // typeObj["Date"] =that.selectVal;
      if(that.selectVal){
        typeObj["StartDate"]= that.selectVal.replace("/","-") + " " +"00:00:00";
      }
     if(that.selectValsell){
      typeObj["EndDate"]= that.selectValsell.replace("/","-") + " "+"23:59:59";
     }
     
      if(that.vipTypeId){
        typeObj["OrderEntry"] = that.vipTypeId;
      }
      
      // typeObj["ChineseName"] = that.auditsearchValue;
      body.RequestBody = JSON.stringify(typeObj);
      that.http.post(app.DEFAULTURL, body).then(data => {
  
        /****判断是否第一页begin****/
        if (PageNumber == 1) {
          // that.dataArrayList =[];
         console.log(data,"拿到的数据")
          that.apiObj['status'] = data.ResponseMessage.Success;
          that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
          that.loading = true;
          that.dataArrayList = [];
        } else {
          if (that.infiniteScroll) {
            that.infiniteScroll.complete();
          }
  
        }
        /****判断是否第一页end****/
        if (data.ResponseMessage.Success) {
          // that.dataArrayList = data.Status.Datas;
          console.log(that.dataArrayList, "dataArrayList");
          data.Status.Datas.forEach(itname=>{
            itname.c_Name=that.com.FormatName(itname.c_Name||"" , !itname.c_IsAuth);
            itname.c_TelPhone=that.com.PhoneNum(itname.c_TelPhone||"" , !itname.c_IsAuth);

            if(itname.a_CreateTime){
              itname.a_CreateTime=itname.a_CreateTime.replace(/-/g,"/").replace("Z",'').replace("-00:00",'').replace("T","");
            }
            that.dataArrayList.push(itname);
          })
          /****上拉加载数据begin****/
          that.RecordCount = data.Status.RecordCount;
          if (that.RecordCount == data.Status.Datas.length || that.RecordCount == that.dataArrayList.length) {
            // that.infiniteScroll.disabled = true;
            // if (that.infiniteScroll) {
              that.infiniteScroll.disabled = true;
            // }
          } else {
            // if (that.infiniteScroll) {
              that.infiniteScroll.disabled = false;
            // }
          }
          /****上拉加载数据end****/
        }else{
          that.msg.Alert(data.ResponseMessage.ErrorMessage);
          that.apiObj['status'] = false;
          that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
          that.loading = true;
        }
  
      }).catch(error => {
        that.apiObj['status'] = false;
        that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
        that.loading = true;
        // console.log(error);
      });
    }
}
